import win from "core/window"
import { btoa } from "core/utils"

export default function authorize ( { auth, authActions, errActions, configs, authConfigs={} } ) {
  let { schema, scopes, name, clientId, consentId, xjwssignature} = auth
  let flow = schema.get("flow")
  let query = []
  console.log(flow);
  switch (flow) {
    case "password":
      authActions.authorizePassword(auth)
      return

    case "application":
      authActions.authorizeApplication(auth)
      return

    case "accessCode":
      query.push("response_type=code")
      break

    case "implicit":
      query.push("response_type=token")
      break

    case "clientCredentials":
      // OAS3
      authActions.authorizeApplication(auth)
      return

    case "authorizationCode":
      // OAS3
      query.push("response_type=code")
      break
  }

  if (typeof clientId === "string") {
    query.push("client_id=" + encodeURIComponent(clientId))
  }
  
    if (typeof consentId === "string") {
    query.push("consent_id=" + encodeURIComponent(consentId))
  }

  let redirectUrl = configs.oauth2RedirectUrl

  // todo move to parser
  if (typeof redirectUrl === "undefined") {
    errActions.newAuthErr( {
      authId: name,
      source: "validation",
      level: "error",
      message: "oauth2RedirectUrl configuration is not passed. Oauth2 authorization cannot be performed."
    })
    return
  }
  query.push("redirect_uri=" + encodeURIComponent(redirectUrl))

  if (Array.isArray(scopes) && 0 < scopes.length) {
    let scopeSeparator = authConfigs.scopeSeparator || "_"

    query.push("scope=" + encodeURIComponent(scopes.join(scopeSeparator)))
  }

  let state = btoa(new Date())

  query.push("state=" + encodeURIComponent("state"))

  if (typeof authConfigs.realm !== "undefined") {
    query.push("realm=" + encodeURIComponent(authConfigs.realm))
  }

  let { additionalQueryStringParams } = authConfigs

  for (let key in additionalQueryStringParams) {
    if (typeof additionalQueryStringParams[key] !== "undefined") {
      query.push([key, additionalQueryStringParams[key]].map(encodeURIComponent).join("="))
    }
  }

  let authorizationUrl = schema.get("authorizationUrl")
  let url = [authorizationUrl, query.join("&")].join(authorizationUrl.indexOf("?") === -1 ? "?" : "&")

  // pass action authorizeOauth2 and authentication data through window
  // to authorize with oauth2

  let callback
  if (flow === "implicit") {
	  console.log("primul if");
    callback = authActions.preAuthorizeImplicit
  } else if (authConfigs.useBasicAuthenticationWithAccessCodeGrant) {
	  console.log("2 if");
    callback = authActions.authorizeAccessCodeWithBasicAuthentication
  } else {
	   console.log("3 if");
    callback = authActions.authorizeAccessCodeWithFormParams
  }
  
  
  console.log(redirectUrl);
  

  win.swaggerUIRedirectOauth2 = {
    auth: auth,
    state: state,
    redirectUrl: redirectUrl,
    callback: callback,
    errCb: errActions.newAuthErr
  }
  
  console.log(win.swaggerUIRedirectOauth2);
  console.log(url);
  console.log(win);
  
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    xhr.setRequestHeader("x-jws-signature", xjwssignature);
	
	xhr.onreadystatechange = function() {
		   if (xhr.readyState == 0) {
		 	console.log( xhr.getAllResponseHeaders());
		 }
		   if (xhr.readyState == 1) {
		 	console.log( xhr.getAllResponseHeaders());
		 }
		   if (xhr.readyState == 2) {
		 	console.log( xhr.getAllResponseHeaders());
		 }
		   if (xhr.readyState == 3) {
		 	console.log( xhr.getAllResponseHeaders());
		 }
            if (xhr.readyState == 4) {
				 win.open(xhr.responseURL);
				console.log(xhr.response);
				console.log(xhr.responseURL);
				console.log(xhr);
				console.log( xhr.getAllResponseHeaders());
	
				
              
            }
        };
	xhr.send();

}



// WEBPACK FOOTER //
// ./src/core/oauth2-authorize.js